import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-100 d-flex flex-wrap align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-primary my-3 flex-grow-1"
}
const _hoisted_3 = { class: "text-primary my-3 flex-grow-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload mr-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "w-100 d-flex align-items-center" }
const _hoisted_9 = {
  class: "mr-2",
  style: {"width":"40px"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cloud-upload mr-2" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle mr-2" }, null, -1)
const _hoisted_17 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Tree = _resolveComponent("Tree")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createBlock(_component_FileUpload, {
    name: "file[]",
    auto: "",
    url: '/api/v1/files/' + (_ctx.room?.id || _ctx.roomId || this.roomIdInternal || 'temp'),
    disabled: _ctx.disabled,
    onBeforeSend: _ctx.addHeader,
    onUpload: _ctx.refresh,
    onProgress: _ctx.updateProgress
  }, {
    header: _withCtx(({ chooseCallback, uploadCallback, clearCallback, files }) => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.room)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_ctx.room.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.header || ' '), 1),
        (!_ctx.disabled && _ctx.hasLinkedProperty)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPropertyFileChooser = true)),
              class: "p-button-raised"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Aus Grundstück")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              onClick: ($event: any) => (chooseCallback()),
              class: _normalizeClass(["p-button-raised", { 'm-0': !_ctx.showDelete }])
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Hochladen")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick", "class"]))
          : _createCommentVNode("", true),
        (_ctx.showDelete)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete'))),
              class: "p-button-raised p-button-danger m-0"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Löschen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.progress)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 4,
              mode: "indeterminate",
              class: "w-100",
              value: _ctx.progress,
              showValue: false
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.safeDescription)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: _ctx.safeDescription
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(({ files, uploadedFiles, onUploadedFileRemove, onFileRemove }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.documents?.data || []), (file) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (file.preview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: file.preview
                }, null, 8, _hoisted_10))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: _normalizeClass(_ctx.iconClass(file)),
                  style: {"font-size":"2rem"}
                }, null, 2))
          ]),
          _createElementVNode("a", {
            class: "mb-0 flex-grow-1 flex-shrink-1",
            style: {"overflow-wrap":"anywhere"},
            href: "javascript:",
            onClick: ($event: any) => (_ctx.downloadFile(file))
          }, [
            _createTextVNode(_toDisplayString(file.name), 1),
            (file.date)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(_ctx.dayjs(file.date)?.format('LLL') || '') + ")", 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_11),
          (!_ctx.disabled)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "flat p-button-icon-only p-button-danger p-button-text",
                icon: "pi pi-trash",
                onClick: ($event: any) => (_ctx.deleteFile(file))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 256)),
      (!_ctx.disabled && !_ctx.documents?.data?.length && !_ctx.hint)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [
                _createTextVNode("Dokumente zum Hochladen hierhin ziehen oder auf \"Hochladen\" klicken.")
              ]),
              _: 1
            })
          ]))
        : (_ctx.hint)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", null, _toDisplayString(_ctx.hint), 1)
            ]))
          : _createCommentVNode("", true),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Dateien aus Grundstück kopieren'),
        visible: _ctx.showPropertyFileChooser,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showPropertyFileChooser) = $event)),
        onHide: _ctx.hideUploadFromPropertyModal,
        onSubmit: _ctx.attachDocumentsFromProperty,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.hideUploadFromPropertyModal
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Hochladen'),
            icon: "pi pi-check",
            autofocus: "",
            type: "submit"
          }, null, 8, ["label"])
        ]),
        default: _withCtx(() => [
          (_ctx.hasLinkedProperty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("p", null, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Bitte wählen Sie das gewünschte Grundstück:")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.linkedProperyId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.linkedProperyId) = $event)),
                  options: _ctx.linkedProperties,
                  "option-label": "name",
                  "option-value": "id"
                }, null, 8, ["modelValue", "options"]),
                (_ctx.linkedProperyId !== null)
                  ? (_openBlock(), _createBlock(_component_Tree, {
                      key: 0,
                      selectionKeys: _ctx.selectedKey,
                      "onUpdate:selectionKeys": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedKey) = $event)),
                      value: _ctx.linkedPropertyFileTree,
                      selectionMode: "checkbox",
                      class: "w-full md:w-30rem"
                    }, null, 8, ["selectionKeys", "value"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 1,
                mode: "indeterminate"
              }))
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide", "onSubmit"])
    ]),
    _: 1
  }, 8, ["url", "disabled", "onBeforeSend", "onUpload", "onProgress"]))
}